import moment from 'moment';

const millisecondsToTime = milliseconds => {
  let hours = ~~(milliseconds / 3600);
  let minutes = ~~((milliseconds % 3600) / 60);
  let time = hours + ':' + (minutes > 0 ? minutes : '0' + minutes);
  return time;
};

const getCurrentDate = () => {
  let today = new Date();
  let dd = today.getDate();
  let mm = today.getMonth() + 1; //January is 0!
  let yyyy = today.getFullYear();
  dd = dd < 10 ? '0' + dd : dd;
  mm = mm < 10 ? '0' + mm : mm;
  today = dd + '/' + mm + '/' + yyyy;
  return today;
};

const dateArrayToDate = dateArray => {
  return new Date(
    dateArray[0] || 0,
    (dateArray[1] || 0) - 1,
    dateArray[2] || 0,
    dateArray[3] || 0,
    dateArray[4] || 0,
    dateArray[5] || 0
  );
};

const formatDateToDateTimeAmPm = date => {
  return moment(date).format('DD/MM/YYYY hh:mm a');
};

const formatDate = date => {
  return moment(date).format('DD/MM/YYYY');
};

const getCurrentHourMinutePlusMinutes = minutes => {
  return moment(new Date())
    .add(minutes, 'm')
    .format('hh:mm a');
};

const formatDateToTimeAmPm = date => {
  return moment(date).format('hh:mm a');
};

export default {
  millisecondsToTime,
  getCurrentDate,
  dateArrayToDate,
  formatDateToDateTimeAmPm,
  formatDateToTimeAmPm,
  getCurrentHourMinutePlusMinutes,
  formatDate,
};



// WEBPACK FOOTER //
// ./src/utils/time.js